// eslint:disable:jsx-no-lambda 
// eslint:disable:react-this-binding-issue
import * as React from 'react';
import { v4 } from 'uuid';
import styles from './choose-chart-type.scss';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { LayoutType } from '../types-store';
import { Value } from 'app/types-shared';
import { LayoutTypeValue } from 'app/area/case-report/constants';

import type { JSX } from "react";

export interface ChooseChartTypeTranslation {
  choose_chart_type_limit_message_singular: string;
  choose_chart_type_limit_message_plural: string;
}

interface ChooseChartTypeComponentProps {
  numberOfGroupByFields: number;
  selectedLayoutType: number;
  layoutTypes: LayoutType[];
  onSetLayoutType: (type: Value) => void;
  onSetPresentationType?: (presentationType?: Value) => void;
  translations?: ChooseChartTypeTranslation;
  classNames?: string;
}

class ChooseChartTypeComponent extends React.Component<ChooseChartTypeComponentProps, {}> {
  private uid: string = v4();

  private tooltipMessage = (lt: LayoutType) => {
    const { translations } = this.props;
    const layoutType = lt.type.d;
    if (translations) {
      const amount = lt.maxSelectionCriteria;
      const text = lt.maxSelectionCriteria > 1
        ? translations.choose_chart_type_limit_message_plural
        : translations.choose_chart_type_limit_message_singular;
      return text?.replace('<LAYOUT_TYPE>', layoutType)?.replace('<AMOUNT>', String(amount));
    }
    return layoutType;
  };
  private handleOnChange = (lt: LayoutType) => {
    if (this.props.numberOfGroupByFields <= lt.maxSelectionCriteria) {
      this.props.onSetLayoutType(lt.type);
    }
    this.props?.onSetPresentationType?.(lt.presentationType);
  };
  private renderLayoutTypeBlock = (lt: LayoutType) => {
    const disabled = this.props.numberOfGroupByFields > lt.maxSelectionCriteria;
    const uniqueId = `chart-type-${lt.type.d.replace(/\s/g, '')}-${this.uid}`;

    const content = <div key={lt.type.v} title={lt.type.d} className={styles.chartOption}>
      <input
        type="radio"
        className="visuallyhidden"
        name={`select-chart-type-${this.uid}`}
        id={uniqueId}
        value={lt.type.v}
        onChange={() => this.handleOnChange(lt)}
        checked={this.props.selectedLayoutType === lt.type.v}
        disabled={disabled}
      />

      <label htmlFor={uniqueId}
        // This is to apply different padding for the bowtie icon
        className={lt.type?.v === LayoutTypeValue.bowtie ? styles.bowtieIcon : ''}>
        <span className="visuallyhidden">{lt.type.d}</span>
        {lt.iconUrl ? <img src={toAbsoluteUrl(lt.iconUrl)} /> : !!lt.type && !!lt.type.d && lt.type.d}
      </label>
    </div>;

    return !!disabled
      ? <Tooltip key={lt.type.v} className="" title={this.tooltipMessage(lt)}>{content}</Tooltip>
      : content;
  };
  public render(): JSX.Element {

    const { layoutTypes, classNames } = this.props;

    if (!layoutTypes) {
      return null;
    }

    return (
      <div className={`btn-group ${styles.chartSelector} ${classNames ? classNames : ''}`}>
        {layoutTypes.map(lt => this.renderLayoutTypeBlock(lt))}
      </div>);
  }
}

export const ChooseChartType = ChooseChartTypeComponent;
